import React from 'react';
import axios from 'axios';
import isEqual from 'react-fast-compare';
import store from '../../store/index';
import {setData, setDataBatch} from '../../actions/index';

const styles = theme => ({
  padding: {
    padding: 16,
  },
});


// TODO: refactor
class AbstractDashboardPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      announcements: [],
      pupils: [],
      isAlreadyLoadedOnce: false,
      isLoading: false,
      isLoaded: false,
    };

    this.updateData = this.updateData.bind(this);
    this.onParentReloadApp = this.onParentReloadApp.bind(this);
  }

  componentDidMount() {
    this.updateData();

    this.storeSubscription = store.subscribe(() => {
      this.updateData();
    });

    window.addEventListener('parent:reload-app', this.onParentReloadApp);
  }

  componentWillUnmount() {
    if (this.storeSubscription) {
      this.storeSubscription();
    }

    window.removeEventListener('parent:reload-app', this.onParentReloadApp);
  }

  updateData() {
    const storeState = store.getState();
    if (
      appType === 'student' ||
      this.state.isLoading ||
      (
        this.state.isAlreadyLoadedOnce &&
        isEqual(storeState.announcements, this.state.announcements) &&
        isEqual(storeState.pupils, this.state.pupils)
      )
    ) {
      return;
    }

    this.setState({
      isLoading: true,
      isAlreadyLoadedOnce: true,
    });

    axios
      .all([
        axios.get(`${window.apiUrl}/announcements`),
        axios.get(`${window.apiUrl}/pupils`),
      ])
      .then(axios.spread((...responses) => {
        const announcementsResponse = responses[0];
        const pupilsResponse = responses[1];

        let newState = {
          user: storeState.user,
          isLoading: false,
          isLoaded: true,
        };

        // Announcements
        if (
            announcementsResponse.data.success &&
            !isEqual(this.state.announcements, announcementsResponse.data.data)
        ) {
          newState.announcements = announcementsResponse.data.data;
        } else if (announcementsResponse.data.meta.hasOwnProperty('parent_email_verify') && announcementsResponse.data.meta.parent_email_verify) {
          newState.announcements = [];
        }

        // Pupils
        if (
            pupilsResponse.data.success &&
            !isEqual(this.state.pupils, pupilsResponse.data.data)
        ) {
          newState.pupils = pupilsResponse.data.data;
        } else if (announcementsResponse.data.meta.hasOwnProperty('parent_email_verify') && announcementsResponse.data.meta.parent_email_verify) {
          newState.pupils = [];
        }

        // Do we have a hash with a pupil ID in it?
        // If so, set that pupil as the currently selected one (if they exist).
        if (
          newState.pupils && // did we fetch any pupils?
          window.location.hash
        ) {
          const hashSplit = window.location.hash.replace('#', '').split(',');
          let selectedPupilIndex = -1;

          newState.pupils.map((pupil, index) => {
            if (pupil.id === parseInt(hashSplit[0])) {
              return selectedPupilIndex = index;
            }
          });
          if (selectedPupilIndex !== -1) {
            const selectedPupil = newState.pupils[selectedPupilIndex];
            selectedPupil.defaultView = hashSplit[1];

            newState.selectedPupil = selectedPupil;
          }
        }
        this.setState(newState, () => {
          // Cleanup variables we don't need for the reducer
          delete newState.isLoading;
          delete newState.isLoaded;
          // Set the state only if any of the keys (announcements, pupils or selectedPupil) is set
          if (Object.keys(newState).length) {
            store.dispatch(setDataBatch(newState));
          }
        });

      }))
      .catch((thrown) => {});
  }

  onParentReloadApp() {
    store.dispatch(setData(null, 'selectedPupil'));
    this.setState({
      announcements: [],
      pupils: [],
      isAlreadyLoadedOnce: false,
    });
    this.updateData();
  }
}

export default AbstractDashboardPage;
